import { Outlet } from "react-router";
import { Box } from "@mui/material";
import Sidebar from "../header";

const DashboardPageLayout = () => {
    return (
        <>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: "100vh",
                    overflow: "auto",
                }}
            >
                <Sidebar />
                <Outlet />
            </Box>
        </>
    );
};

export default DashboardPageLayout;
